import { t } from '@avalara/bat-apps-shared/i18n';

import { SIcon } from '@avalara/skylab-sdk/react';

import styled from 'styled-components';
import BuyButton from '../buy-button';
import { FormContainer } from '../styled/forms';

const LightGreenIcon = styled(SIcon)`
  color: var(--color-feedback-text-success);
`;

const ELR_BENEFIT_KEYS = [
  'client.offer.elr-review.benefit-1',
  'client.offer.elr-review.benefit-2',
  'client.offer.elr-review.benefit-3',
  'client.offer.elr-review.benefit-4',
] as const;

const ELR_NEXT_STEP_KEYS = [
  'client.offer.elr-review.next-step-1',
  'client.offer.elr-review.next-step-2',
  'client.offer.elr-review.next-step-3',
  'client.offer.elr-review.next-step-4',
] as const;

const ElrReview = () => {
  const productName = t('client.offer.elr-review.product-name');

  return (
    <FormContainer>
      <h1 className='pad-bottom-md'>{t('client.headings.review-your-order')}</h1>
      <p>{t('client.general.your-product-is-almost-ready', { productName })}</p>

      <p className='font-bold margin-top-sm pad-bottom-sm'>{t('client.general.what-you-get')}</p>
      {ELR_BENEFIT_KEYS.map((key) => (
        <p key={key}>
          <LightGreenIcon name='check' className='margin-right-sm' />
          {t(key)}
        </p>
      ))}

      <p className='margin-top-md pad-bottom-sm'>{t('client.offer.elr-review.after-provisioned-intro')}</p>
      <ul className='margin-left-md margin-bottom-md'>
        {ELR_NEXT_STEP_KEYS.map((key) => (
          <li key={key}>{t(key)}</li>
        ))}
      </ul>

      <p className='margin-top-md'>{t('client.offer.elr-review.account-setup-no-card', { productName })}</p>

      <BuyButton />
    </FormContainer>
  );
};

export default ElrReview;
